module.exports = __webpack_public_path__ + "media/fonts/Objectivity-Bold-a184af52b6d3e474ad67368dc3e522f2.woff2";